import { Form, Input, Button } from 'antd';

const ContactForm = () => {
  const onFinish = (values) => {
    console.log('Received values:', values);
  };

  return (
    <div className="py-5" id="contact">
      <h2 className="text-center mb-4">Contáctanos</h2>
      <Form layout="vertical" onFinish={onFinish} className="mx-auto" style={{ maxWidth: 600 }}>
        <Form.Item label="Nombre" name="name" rules={[{ required: true, message: 'Por favor ingresa tu nombre' }]}> 
          <Input />
        </Form.Item>
        <Form.Item label="Correo Electrónico" name="email" rules={[{ required: true, type: 'email', message: 'Correo inválido' }]}> 
          <Input />
        </Form.Item>
        <Form.Item label="Mensaje" name="message" rules={[{ required: true, message: 'Escribe tu mensaje' }]}> 
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">Enviar</Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default ContactForm;